// Gate players can receive the same PLAY more than once: the server re-sends
// the announcement that's still 'playing' whenever a player (re)registers, e.g.
// after a brief socket reconnect. Replaying it restarted (gate display) or
// repeated (tablet) the same announcement. Track ids per player:
//   'active'   — accepted (playing or queued): ignore a repeat
//   'finished' — already played: don't replay; re-report played instead (the
//                first report may have been lost, which is why it's re-sent)
export function createPlayDedupe(limit = 100) {
  const state = new Map(); // announcementId → 'active' | 'finished'
  const trim = () => { while (state.size > limit) state.delete(state.keys().next().value); };
  return {
    check(id) { return id == null ? null : state.get(String(id)) || null; },
    accept(id) { if (id != null) { state.set(String(id), 'active'); trim(); } },
    finish(id) { if (id != null) { state.delete(String(id)); state.set(String(id), 'finished'); trim(); } },
    // Playback was cut off without finishing (Emergency Pause, skip, stop): the
    // server re-sends these as fresh PLAYs (e.g. Resume restarts the interrupted
    // announcement with the same id), so they must be accepted again.
    release(id) { if (id != null) state.delete(String(id)); },
  };
}
